import React from "react";
import { Button, Form } from "react-bootstrap";
import LoadingSpinner from "../../Components/spinner";
import { searchProvinces } from "../../services/axios/apiManager";

const ProvinceFilters = ({
  pagination,
  setPagination,
  query,
  setQuery,
  filters,
  setFilters,
  setProvinces,
  fetchProvinces,
  filtering,
  setFiltering,
}) => {
  const getFilteredProvinces = async (e) => {
    const temp = { ...pagination };
    temp.currentPage = 1;
    setFilters(e.target.value);
    const string = `status=${e.target.value}`;
    await fetchProvinces(temp, string);
  };

  // // // Reset All Filters to default
  const resetFilters = async () => {
    setFilters(3);
    setQuery("");
    const temp = { ...pagination };
    temp.currentPage = 1;
    await fetchProvinces(temp);
  };

  // // // Search by name
  const handleSearch = async (e) => {
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      setFiltering(true);
      const res = await searchProvinces(string);
      if (res?.data?.data) {
        setProvinces(res.data.data);
      }
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
      setFiltering(false);
    } else {
      await fetchProvinces(pagination);
    }
  };

  return (
    <div className="col-md-10 row">
      <div className="col-md-3 py-2">
        <Form.Control
          type="text"
          placeholder="Search Provinces..."
          value={query}
          onChange={(e) => {
            handleSearch(e);
          }}
          className="bg-dark text-light border-light input-placeholder-light"
        />
      </div>
      <div className="col-md-3 py-2">
        <Form.Select
          name="status"
          value={filters}
          onChange={(e) => {
            getFilteredProvinces(e);
          }}
          className="bg-dark border-light text-light"
        >
          <option value="3">Active & Inactive</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
          <option className="text-danger" value="2">
            Deleted
          </option>
        </Form.Select>
      </div>
      <div className="col-md-1 py-2 mx-2">
        {filtering ? (
          <LoadingSpinner size={"md"} />
        ) : (
          <div className="row ">
            <Button
            title="Reset Filters And Rrfresh Records"
              className="btn btn-success"
              onClick={() => {
                resetFilters();
              }}
            >
              Reset
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
export default ProvinceFilters;
